import { render, staticRenderFns } from "./IssueInlandVesselCertificate.vue?vue&type=template&id=675f1541"
import script from "./IssueInlandVesselCertificate.vue?vue&type=script&lang=ts"
export * from "./IssueInlandVesselCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports